<template>
  <header class="bg-white shadow">
    <div class="container mx-auto px-4 py-4 flex items-center justify-between">
      <h1 class="text-xl font-bold flex items-center justify-center gap-2">
        <router-link to="/" class="flex hover:text-gray-900"><img class="h-6" src="/sticker.png"
            alt="">工具豬豬</router-link>
      </h1>

      <nav class="flex gap-4 text-gray-600">
        <router-link to="/" class="flex hover:text-gray-900">
          <img class="h-6" src="/sticker.png" alt="">所有工具</router-link>
        <a class="flex hover:text-gray-900" href="https://store.line.me/stickershop/product/19255273/zh-Hant"
          target="_blank" rel="noopener noreferrer">
          <img class="h-6" src="/sticker.png" alt="">
          line 貼圖
        </a>
      </nav>
    </div>
  </header>
</template>
